<template>
  <el-dialog :visible.sync="state" width="1100px" style="margin: 0;" @close="close" custom-class="_dialog_height" top="8vh" append-to-body>
    <div class="settin-box">
      <div class="_right">
        <div class="content_right">
          <div class="table">
            <span class="title">{{ title }}</span>
            <div class="head_line">
              <div>
                <el-input type="text" v-model="form.SearchName" :placeholder="$t('StorageOutKu.GoodsName')"></el-input>
                <el-button class="button_primary" icon="el-icon-search" @click="getData()">{{ $t('BasicDept.search') }}</el-button><!--搜索-->
              </div>
            </div>
            <div class="content_table">
              <div class="_filter">
              </div>
              <el-table border :data="DataList" height="452px" v-loading="loading" stripe ref="tableList">
                <el-table-column type="selection" width="55"> </el-table-column>
                <el-table-column :label="$t('Approve.ApproverUserName')" prop="UserName" min-width="120px">
                </el-table-column>
                <el-table-column :label="$t('Approve.ApproverStatusName')" prop="ApproverStatusName" min-width="120px">
                  <template slot-scope="scope">
                    <span :style="`color:${scope.row.PublicFormFontColor};background-color:${scope.row.PublicFormBgColor}`"
                      class="_span_icon">{{ scope.row.ApprovalStatusName }}</span>
                  </template>
                </el-table-column>
                <el-table-column :label="$t('Approve.ApproverTimeText')" prop="ApprovalTimeText" min-width="120px">
                </el-table-column>
              </el-table>
              
            </div>
          </div>
        </div>
      </div>
    </div>
  </el-dialog>
</template>
  
<script>
import {

} from "@/api/user";
import mixins from "@/mixins";
export default {
  watch: {
    filterText(val) {
      this.$refs.tree.filter(val);
    }
  },
  name: "SettingView",
  props: {
    type: {
      type: Boolean,
      default: false
    },
    GoodsStatus: {
      type: String,
      default() {
        return '';
      }
    },
    DataList: {
      type: Array,
      default() {
        return []
      }
    },
    warehouseid: {
      type: [String, Number],
      default: ''
    },
    seltype: {
      type: Boolean,
      default: true
    }
  },
  components: {},
  mixins: [mixins],
  data() {
    return {
      tabs: 0,
      menutab: 0,
      ID: "",
      level: "",
      drawer: false,
      filterText: "",
      icon: '',
      title: "",
      currentPage: 1,
      Title: "",
      checked: true,
      upload: false,
      dialogFormVisible: false,
      tableData: [],
      TableList: [],

      TotalCount: 0,

      form: {
        PageIndex: 0,
        PageSize: 20,
        OnlyShowStock: 1,
        StartTime: '',
        EndTime: '',
        SearchName: '',
        CategoryID: '',
        WarehouseID: '',
        InKuStatus: '',
        GoodsStatus: ''
      },
      loading: false,
      TableOk: false,
      data: [],
      value: 1,
      addList: [],
      multipleSelection: []
    };
  },
  computed: {
    state: {
      get() {
        return this.type;
      },
      set() {

      }
    }
  },
  mounted() {
    this.tableData = this.DataList; 
  },
  methods: {
   getData(){
    this.tableData =  this.tableData.filter(item => item.UserName.startsWith(this.form.SearchName)); // 例如，筛选出名字以'A'开头的项 
   },
    handleClick(row) { 
    },
    close() {
      this.$emit('close')
    },
  },
};
</script>
<style lang="scss" scoped>
::v-deep ._dialog_height {
  width: 1100px !important;
  height: 730px !important;
}
.el-divider--horizontal {
  margin: 13px 0;
}
._button {
  display: flex;
  justify-content: end;
}
::v-deep .component_footer {
  align-items: end !important;
}
.el-pagination {
  justify-content: end !important;
}
::v-deep .component_footer {
  align-items: end !important;
}
.but_add {
  display: flex;
  justify-content: space-between;
}
::v-deep .el-dialog__body {
  padding: 0px 20px !important;
}
/deep/.el-dialog {
  height: 650;
  overflow-y: auto;
}
/deep/ .el-table__empty-block {
  width: 20%;
  min-width: 121%;
  max-width: 20%;
  padding-right: 20%;
}
.companyimg {
  line-height: 150px;
}

.el-icon-plus {
  border: 1px dashed;
  // background-color: #8c939d;
}

//头像
.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}

.avatar-uploader-icon {
  font-size: 15px;
  color: #8c939d;
  width: 135px;
  height: 128;
  line-height: 120px;
  text-align: center;
}

.el-input--mini .el-input__inne {
  height: 39px;
}

.avatar {
  width: 135px;
  height: 128;
  display: block;
}

//
.ul_but li {
  margin-bottom: 20px;
}

.ul_but:hover {
  cursor: pointer;
}

.custom-tree-node {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 14px;
  padding-right: 8px;
}

.settin-box {
  width: 100%;
  height: calc(100vh - 240px);
  display: flex;
  background-color: #fff;
  border-radius: 5px;
  position: relative;

  ul {
    padding: 0;
    margin: 0;
  }

  ._right {
    display: flex;
    flex: 1;
    position: relative;

    .content_left {
      width: 25%;
      height: calc(100vh - 700px);
      padding: 10px 10px;
      font-size: 19px;

      .tabs {
        display: flex;
        height: 50px;

        .tabs_item {
          display: block;
          padding: 10px;
          line-height: 30px;

          &:hover {
            color: #409eff;
            cursor: pointer;
          }
        }
      }

      .content {
        padding: 20px 10px;

        span {
          font-size: 14px;
        }

        .title_box {
          width: 100%;
          display: flex;
          justify-content: space-between;
          align-items: center;

          .el-icon-plus {
            color: #409eff;
            cursor: pointer;
          }
        }

        .title {
          font-size: 14px;
          font-weight: 550;
          display: block;
          margin-bottom: 20px;
        }

        ul li {
          font-size: 14px;
          display: flex;
          align-items: center;
          height: 40px;
          padding: 0 0 0 10px;
          border-radius: 20px;
          margin: 10px 0;

          // &:hover {
          //   background-color: #409eff;
          //   color: #fff;
          //   cursor: pointer;
          // }

          span {
            margin-left: 10px;
          }
        }
      }
    }

    .content_right {
      height: calc(100vh - 700px);
      position: absolute;
      width: 100%;
      right: 0;
      padding: 10px;

      .head_line {
        display: flex;
        align-items: center;
        justify-content: space-between;

        height: 50px;
        .el-input {
          width: 250px !important;
        }

        .el-button {
          margin-left: 20px;
        }
      }

      .content_table {
        width: 100%;
        overflow: hidden;
        box-shadow: 0 0 5px rgb(201, 199, 199);
      }
    }
  }

  @media screen and (max-width: 1400px) {
    ._left {
      display: none;
    }
  }
}
.dialog-footer {
  text-align: right;
}
._filter {
  height: 0px;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  width: 100%;

  span {
    margin-right: 20px;
    color: #1a73e8;
    font-size: 14px;
    cursor: pointer;

    .el-icon-refresh {
      margin-left: 10px;
      font-size: 16px;
    }
  }
}

.check {
  color: #409eff;
  border-bottom: 2px solid #409eff;
}

.listindex {
  color: #fff;
  background-color: #409eff;
}

._filter_btn {
  width: 100%;
  text-align: center;
  position: absolute;
  bottom: 100px;

  .el-button {
    width: 100px;

    &:nth-child(2) {
      margin-left: 50px;
    }
  }
}
</style>